import React, { useState, useEffect } from "react";
import { createGlobalStyle } from 'styled-components';
import axios from 'axios';
import moment from 'moment';
import { loader } from 'helpers';

// Global Style
const GlobalStyle = createGlobalStyle`
	#loader {
		width: 50px;
		display: block;
		margin: 0 auto;
	}

	table#table-details {
		margin-bottom: 0px;
		font-size: 13px;

		thead {

			th {
				border-bottom: 0;
				
				&:nth-child(1) {
					width: 100px;
				}
			}
		}

		tbody {

			tr {

				&:last-of-type {

					td {
						border-bottom: 0;
					}
				}

				td {

					.badge {
						font-size: 13px;
					}

					&:nth-child(2) {
						width: 100px;
					}

					&:nth-child(3) {
						max-width: 200px;

						.hljs {
							overflow: hidden !important;
						}

						pre.pre-errors,
						.highlight-wrapper {
							display: block;
							width: 100%;
							max-height: 150px;
							overflow: auto;
							border: 1px solid var(--plenoil-blue-light);
							background: white;
							margin-bottom: 15px;
						}
					}

					&:last-of-type {
						width: 100px;
					}
				}
			}
		}

		td, th {
			cursor: auto;
		}
	}
`;

// Axios cancel token
let cancelTokenSource = null;
 
export default function DetailsRow(props) {
	// State
	const [ data, setData ] = useState([]);
	const [ loading, setLoading ] = useState(false);

  	function getData(id) {
  		setLoading(true);

		axios.get('/lavaderos-logs/get-reception/' + id, {
			cancelToken: cancelTokenSource.token
		})
	  	.then((response) => {
	  		setData({...response.data});
	  	})
	  	.catch((error) => {
	  		if ( axios.isCancel(error) ) return;
	  		setData([]);
	  	}).then(() => {
	  		setLoading(false);
	  	});		
  	}

  	function addLog(event, reception_id, type) {
  		event.preventDefault();

  		axios.post('/lavaderos-logs/'+type+'-reception', {
  			id: reception_id
  		}, {
			cancelToken: cancelTokenSource.token
		})
	  	.then((response) => {
	  		getData(reception_id);
	  	})
	  	.catch((error) => {
	  		if ( axios.isCancel(error) ) return;
	  	});	
  	}

  	// Did mount
	useEffect(() => {
		cancelTokenSource = axios.CancelToken.source();
  		
  		getData(props.id); 

  		return function cleanup() {
           	cancelTokenSource.cancel();
        }
  	}, [props.id]);

  	let rows = [];
  	if ( data.reception && data.reception.log ) {
  		let log = [...data.reception.log].reverse();
  		log.forEach((el, idx) => {
  			// Prepare actions
  			let actions = [];
  			if ( idx === 0 ) {
	  			if ( el.status === "sender-retry" ) {
	  				actions.push(<a key="retry" href="." className="btn btn-sm btn-danger mb-2" onClick={(e) => addLog(e, props.id, 'cancel')}>Cancelar</a>);
	  			}

	  			if ( 
					el.status === "sender-retry" || 
					el.status === "sender-error" || 
					el.status === "converter-error" || 
					data.reception.last_status === "converter-error" // Fix: ocurrieron unos errores de codificación y había que mirar este estado en vez del del log por que no quedó registrado
				) {
	  				actions.push(<a key="ignore" href="." className="btn btn-sm btn-secondary mb-2"  onClick={(e) => addLog(e, props.id, 'ignore')}>Ignorar</a>);
	  				actions.push(<hr key="hr" />);
	  				actions.push(<a key="reconvert" href="." className="btn btn-sm btn-secondary mb-2"  onClick={(e) => addLog(e, props.id, 'reconvert')}>Reconvertir</a>);
	  			}	
  			}

  			// Push
	  		rows.push(
	  			<tr key={idx}>
	  				<td>
	  					<div>{ el.date ? moment(el.date).format('DD-MM-YYYY') : '' }</div>
						<small>{ el.date ? moment(el.date).format('HH:mm:ss') : '' }</small>
	  				</td>
	  				<td>
  						<span className={"badge bg-" + (props.logStatuses[el.status]?.color)}>{props.logStatuses[el.status]?.name}</span>
	  				</td>
	  				<td>
	  					<DetailsGenerator 
							el={el}
							reception={data.reception}
							converted={data.converted}
							log={log}
						/>
	  				</td>
	  				<td className="text-center">
	  					{actions}
	  				</td>
	  			</tr>
	  		);
  		});
	  }

  	// Render
	return (
		<React.Fragment>
			<GlobalStyle />
			{ loading ? loader() : '' }
			{ rows.length > 0 &&
				<table className="table table-sm" id="table-details">
					<thead>
						<tr>
							<th>Momento</th>
							<th>Tarea</th>
							<th>Detalles</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{rows}
					</tbody>
				</table>
			}
		</React.Fragment>
	);
}









let cancelTokenSourceGenerator = null;

export function DetailsGenerator(props) {
	const data = props.el;
	const reception = props.reception;
	const converted = props.converted;
	let completeLog = props.log;

	let [company, setCompany] = useState(null); // Needed for sender-init

	useEffect(() => {
		if ( data.status !== 'sender-init' ) return;
		if ( !data.payload.company_id ) return;

		cancelTokenSourceGenerator = axios.CancelToken.source();

		axios.get('/companies/get/' + data.payload.company_id, {
			cancelToken: cancelTokenSourceGenerator.token
		})
	  	.then((response) => {
	  		setCompany({...response.data})
	  	})
	  	.catch((error) => {
	  		if ( axios.isCancel(error) ) return;
	  	})

		return function cleanup() {
			cancelTokenSourceGenerator.cancel();
        }
	}, [data]);

	if ( data.status === "converter-error" ) {
		return (
			<React.Fragment>
				<div>{data.payload.message}</div>
				<div>
					<pre className="pre-errors">
						{data.payload.stacktrace}
					</pre>
				</div>
			</React.Fragment>
		);
	}
	if ( data.status === "converter-finished" ) {
		if ( converted ) {
			return (
				<div className="highlight-wrapper">
					<pre><code>{converted.data}</code></pre>
				</div>
			);
		}
	}
	if ( data.status === "converter-count" ) {
		if ( data.payload.count !== undefined ) return <div>Recuento: {data.payload.count}</div>
	}
	if ( data.status === "converter-init" ) {
		if ( data.payload.attempt !== undefined ) return <div>Intento: {data.payload.attempt}</div>
	}
	if ( data.status === "data-received" ) {
		if ( reception ) {
			return (
				<div className="highlight-wrapper">
					<pre><code>{JSON.stringify(reception.data, null, 2)}</code></pre>							
				</div>
			);
		}
	}

	if ( data.status === "sender-init" ) {
		// Get attempt
		let attempt = data.payload.attempt !== undefined ? <div className="d-inline-block me-2">Intento: {data.payload.attempt}</div> : null;
		
		// Get company_code
		let company_code = data.payload.company_code !== undefined ? <div>Código empresa: {data.payload.company_code}</div> : null;
		
		// Get company
		let company_name = company ? <div>Empresa: {company?.name}</div> : null;
		
		// Get actual position
		let actualPosition = 0;
		completeLog = [...completeLog].reverse();
		for(let idx in completeLog) {
			if ( completeLog[idx].status !== "sender-init" ) continue;
			if ( completeLog[idx] === data ) break;
			actualPosition++;
		}

		// Get sent
		let sent = null;
		if ( converted && converted.sent_ids && converted.sent_ids[actualPosition] !== undefined ) {
			let sent_rows = [];
			for(let idx in converted.sent_ids[actualPosition]) {
				sent_rows.push(<li key={idx}>&nbsp;&nbsp;&nbsp;#{converted.sent_ids[actualPosition][idx]}</li>);
			}
			sent = <div style={{marginTop: '10px'}}>
				{ sent_rows.length !== 0 ? <div className="text-success">Estructuras enviadas</div> : null }
				<ul className="list-unstyled">
					{sent_rows}
				</ul>
			</div>;
		}

		// Get unsent
		let unsent = null;
		if ( converted && converted.send_errors && converted.send_errors[actualPosition] !== undefined ) {
			let unsent_rows = [];
			for(let idx in converted.send_errors[actualPosition]) {
				unsent_rows.push(<li key={idx}>&nbsp;&nbsp;&nbsp;#{idx}: {converted.send_errors[actualPosition][idx]}</li>);
			}
			unsent = <div style={{marginTop: '10px'}}>
				{ unsent_rows.length !== 0 ? <div className="text-danger">Errores recibidos</div> : null }
				<ul className="list-unstyled">
					{unsent_rows}
				</ul>
			</div>;
		}

		// Render
		return (
			<React.Fragment>
				{attempt}
				{/* <span className="badge bg-light text-secondary me-2">{company_code}</span> */}
				<span className="badge bg-light text-secondary me-2">{company_name}</span>
				{sent}
				{unsent}
			</React.Fragment>
		);
	}

	if ( data.status === "sender-retry" ) {
		if ( data.payload.time !== undefined ) return <div>Nuevo intento en: {data.payload.time}</div>
	}

	if ( data.status === "sender-error" ) {
		return (
			<React.Fragment>
				<div>{data.payload.message}</div>
				<div>
					<pre className="pre-errors">
						{data.payload.stacktrace}
					</pre>
				</div>
			</React.Fragment>
		);
	}

	return (
		null
	);
}